import { useMutation, useQuery } from "@tanstack/react-query";
import React from "react";
import { getVideos, deleteVideoId } from "../../api/gallery.api";
import { queryError, showAlert } from "../../utils/helpers";

const AdminGallery = () => {
  const { data, refetch } = useQuery(['admin-videos'], getVideos, {
    onSuccess: (res) => {
      if (!res.status) {
        return showAlert({
          title: "Oops!",
          msg: res.errors ? res.errors[0].msg : res.message,
          icon: "error"
        });
      }
    },
    onError: () => queryError()
  });

  const videos = data?.value || [];

  const { mutate: deleteVid } = useMutation(deleteVideoId, {
    onSuccess: (res) => {
      if (!res.status) return queryError();
      showAlert({ title: "Success", msg: "Video deleted successfully", icon: "success" });
      refetch();
    },
    onError: () => queryError()
  });

  const handleDelete = async (id) => {
    let conf = window.confirm("Are you sure you want to delete this video?");
    if (!conf) return;
    deleteVid({ id });
  };

  return (
    <div className="sb-masonry-grid">
      <div className="sb-grid-sizer" />
      {videos.map(video => (
        <div key={video._id} className="sb-grid-item sb-item-50">
          <div className="sb-menu-item sb-mb-30">
            <div className="sb-card-tp">
              <h4 className="sb-card-title">{video.title}</h4>
            </div>
            <div className="sb-description" style={{ textAlign: "center" }}>
              <video src={video.videoUrl} controls width="100%" height="200px" className="mb-3" />
              <button className="btn btn-sm btn-danger" onClick={() => handleDelete(video._id)}>
                <i className="fa fa-trash-alt"></i> Delete
              </button>
            </div>
          </div>
        </div>
      ))}
      {videos.length === 0 && <p style={{textAlign:"center", width: "100%"}}>No videos uploaded yet.</p>}
    </div>
  );
};

export default AdminGallery;
